export default __webpack_public_path__ + "img/0634c7224c503c6bc78aa5b6261943ec.svg";